























































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { TypeformForm } from '@/api/model/typeform/typeform-form'
import { TypeformFieldUnion } from '@/api/model/typeform/typeform-field'
import { TypeformLogicJump } from '@/api/model/typeform/typeform-logic-jump'
import { TypeformResponseAnswerHook } from '@/api/model/typeform/typeform-response-answer-hook'
import HighlightReferences from '@/views/Company/Settings/Typeform/Forms/Detail/HighlightReferences.vue'
import LogicJump from '@/views/Company/Settings/Typeform/Forms/Detail/LogicJump.vue'
import { Pipeline } from '@/api/model/pipeline'
import { PipelinePhase } from '@/api/model/pipeline-phase'
import { PipelineAPI } from '@/api/backend-client'

@Component({
    components: {
        HighlightReferences,
        TypeformLogicJump: LogicJump,
    },
})
export default class Field extends Vue {
    @Prop({ required: true }) readonly form!: TypeformForm
    @Prop({ required: true }) readonly field!: TypeformFieldUnion
    @Prop({ default: true }) readonly sortable!: boolean
    @Prop({ default: false }) readonly hooksDisabled!: boolean
    @Prop() readonly hooks!: TypeformResponseAnswerHook[]
    pipelines: Pipeline[] = []
    loading: boolean = false

    mounted() {
        this.loadContent()
    }

    async loadContent(): Promise<void> {
        this.loading = true
        this.pipelines = await PipelineAPI.getOwnPipelines()
        this.loading = false
    }

    getPipeline(id: string): Pipeline|null {
        return this.pipelines.find(pipeline => pipeline.id === id) || null
    }

    getPhase(id: string): PipelinePhase|null {
        return this.pipelines.flatMap(pipeline => pipeline.phases).find(phase => phase.id === id) || null
    }

    get sortableIcon(): string {
        return this.sortable ? 'icon-grip-vertical' : 'icon-lock'
    }

    get sortableIconClass(): string {
        return this.sortable ? 'cursor-move' : ''
    }

    get fieldIcon(): string {
        return 'icon-typeform-' + this.field.type.replace('_', '-')
    }

    get title(): string {
        return this.field.title
    }

    get description(): string {
        if (this.field.properties.description) {
            return this.field.properties.description as string
        }

        return ''
    }

    get logicJump(): TypeformLogicJump|null {
        return this.form.getLogicForField(this.field)
    }

    get supportsLogicJump(): boolean {
        return this.form.getOrCreateLogicForField(this.field) !== null
    }

    onEdit() {
        this.$emit('edit')
    }

    onEditHooks() {
        this.$emit('editHooks')
    }

    onEditLogicJump() {
        this.$emit('editLogicJump')
    }

    onDelete() {
        this.$emit('delete')
    }
}
